export function initGoldTabs() {
  const packageButtons = document.querySelectorAll('[data-package-tab]');
  const packagePanels  = document.querySelectorAll('[data-package-panel]');

  if (!packageButtons.length) return;

  packageButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const index = button.getAttribute('data-package-tab');
      packageButtons.forEach((btn) => btn.classList.toggle('is-active', btn.getAttribute('data-package-tab') === index));
      packagePanels.forEach((panel) => panel.classList.toggle('is-active', panel.getAttribute('data-package-panel') === index));
    });
  });
}
